import './style.scss';

import React, { Fragment } from 'react';
import ProductImage from 'components/ui/productImage';
import QtyDiscount from 'components/product/qtyDiscount';
import View from 'components/ui/view';
import Text from 'components/ui/text';

export default function BaseProductItem({
  product,
  renderOnHover,
  includeItemProps
}) {
  return (
    <div className="prod-item">
      <ProductImage
        product={product}
        alt={product.title}
        itemProp={includeItemProps ? 'image' : undefined}
        className="prod-item__img"
      />
      <View padding="xs" className="text-overflow text-left prod-item__descr">
        <Text
          weight="bold"
          className="text-overflow"
          otherProps={{ itemProp: includeItemProps ? 'name' : undefined }}
        >
          {product.title}
        </Text>
        <div
          className="text-overflow"
          itemProp={includeItemProps ? 'description' : undefined}
        >
          {product.subtitle}
        </div>
        <div className="text-overflow">
          {product.volume}
          {!!product.price && (
            <Fragment>
              {' '}
              |{' '}
              {!!product.regularPriceDisplay &&
                product.regularPriceDisplay !== product.priceDisplay && (
                  <span className="text-light strikethrough">
                    ${product.regularPriceDisplay}
                  </span>
                )}
              ${product.priceDisplay}
            </Fragment>
          )}
        </div>

        {!!product.price &&
          !!product.package_qty && (
            <QtyDiscount product={product} textProps={{ weight: 'med' }} />
          )}
      </View>

      {renderOnHover && (
        <div className="prod-item__on-hover">{renderOnHover()}</div>
      )}
    </div>
  );
}



// WEBPACK FOOTER //
// ./shared/components/productItem/base.js